import { AfterViewInit, Component, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { TranslateService } from '@services/translate.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { UserHelper } from '@helpers/user.helper';
import { DataHelper } from '@helpers/data.helper';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { environment } from '@environments/environment';
import { LiveStreamService } from '@services/liveStream.service';
import { OddModel } from '@app/models/odd.model';

@Component({
  selector: 'livematch-component',
  templateUrl: '../sharedTemplates/livematch.component.html',
})
export class LiveMatchComponent implements AfterViewInit, OnChanges, OnDestroy {
  DEFAULT_SLICE_COUNT = 30;
  constructor(
    public _DataHelper: DataHelper,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    public _UserHelper: UserHelper,
    public _Router: Router,
    public _LiveStreamService: LiveStreamService
  ) {
    this.favoriteList = this._DataHelper.getLiveFavoriteTournamentData();
    this.DEFAULT_SLICE_COUNT = environment.livePageIsPagination ? 30 : 1000;

    this.subscribeWindowSize = this._UiHelper.windowResized.subscribe(c => {
      this.styles.vScrool.height = this._UiHelper.windowsHeight - 260 + 'px';

      if (this.liveHeight.height == 'auto') {
        this.styles.vScrool.height = 'auto';
      }
    });
    this.styles.vScrool.height = this._UiHelper.windowsHeight - 260 + 'px';
  }

  favoriteList: Array<number> = [];

  @Input()
  oddLiveMarketingValue = [0];

  @Input()
  isInitialized = false;

  @Input()
  isLoadMore = true;

  @Input()
  __ResultLiveData: Observable<any>;

  @Input()
  liveDataLength: number;

  @Input()
  isFavSection = false;

  @Input()
  isHeaderShow = true;

  @Input()
  _selectedOdds: OddModel[] = [];

  @Input()
  liveHeight = {
    height: '1100px',
  };
  @Input() sportSliderChanges = '';

  @Input()
  tippbarstyle = 'tipp-bar';

  isSmallDesktop = false;

  styles = {
    vScrool: { height: this._UiHelper.windowsHeight - 260 + 'px' },
    vScroolFAV: {},
  };

  oddTypes = this._DataHelper.oddTypes;

  @ViewChild(VirtualScrollerComponent, { static: false })
  subscribeWindowSize;
  subscribeWindowSize2;

  eventDetailEventId = 0;
  eventDetailEventIdOld = 0;

  sliceCount = this.DEFAULT_SLICE_COUNT;
  isShowLoadMore = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sportSliderChanges) {
      this.sliceCount = this.DEFAULT_SLICE_COUNT;
      this.isShowLoadMore = true;

      const mPageElement = document.querySelector('.main-page');

      if (mPageElement) {
        // mPageElement.scroll({ top: 0, behavior: 'smooth' });
      }
    }
  }
  handleNextData() {
    if (this.liveDataLength && this.sliceCount + this.DEFAULT_SLICE_COUNT > this.liveDataLength) {
      this.isShowLoadMore = false;
    }
    this.sliceCount = this.sliceCount + this.DEFAULT_SLICE_COUNT;
  }
  ngAfterViewInit(): void {
    this._UiHelper.windowsWidth < 1400 ? (this.isSmallDesktop = true) : (this.isSmallDesktop = false);
    this.subscribeWindowSize2 = this._UiHelper.windowResized.subscribe(x => {
      this._UiHelper.windowsWidth < 1400 ? (this.isSmallDesktop = true) : (this.isSmallDesktop = false);
    });

    if (this.liveHeight.height == 'auto') {
      this.styles.vScrool.height = 'auto';
    }
    // console.warn("oddLiveMarketingValue",this.oddLiveMarketingValue);
    // console.warn("isInitialized",this.isInitialized);
    // console.warn("_selectedOdds",this._selectedOdds);
    // console.warn("liveDataLength",this.liveDataLength);
    // console.warn("__ResultLiveData",this.__ResultLiveData);
    // console.warn("isFavSection",this.isFavSection);
    // console.warn("sportSliderChanges",this.sportSliderChanges);
    // console.warn("liveMatch",this.oddLiveMarketingValue);
    // console.warn("liveMatch",this.oddLiveMarketingValue);
  }

  ngOnDestroy(): void {
    if (this.subscribeWindowSize != undefined) {
      this.subscribeWindowSize.unsubscribe();
    }

    if (this.subscribeWindowSize2 != undefined) {
      this.subscribeWindowSize2.unsubscribe();
    }
  }

  clickOdd(oddId) {
    this._ApiService.addLiveOdd(oddId);
  }

  addOddListener(e) {
    this.clickOdd(e);
  }

  sportName(e) {
    if (typeof this.oddLiveMarketingValue === 'object') {
      const _a = [];
      this.oddLiveMarketingValue.forEach(_y => {
        Object.prototype.hasOwnProperty.call(this.oddTypes[_y], e) ? _a.push(e) : _a.push('all');
      });
      return _a;
    } else if (typeof this.oddLiveMarketingValue === 'string' || typeof this.oddLiveMarketingValue === 'number') {
      return Object.prototype.hasOwnProperty.call(this.oddTypes[this.oddLiveMarketingValue], e) ? [e] : ['all'];
    }
  }
  eventDetailEventIdListener(e) {
    this.eventDetailEventId = e;

    if (e == this.eventDetailEventIdOld) {
      this.eventDetailEventId = 0;
      this.eventDetailEventIdOld = 0;
    } else {
      this.eventDetailEventIdOld = e;
    }
  }

  pairWithMatchID(index: number, event: any) {
    const matchId = event.MatchId && event.EventId;
    return matchId + event.SportNameOriginal;
  }
}
